if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        // BaadMay code start for cart drawer
        setTimeout(function() {
          var domainShop = "bata-pakistan.myshopify.com";
        
          function calculateCartInstallment() {
              var storedData = sessionStorage.getItem("baadmayData");
        
              if (storedData) {
                  processData(JSON.parse(storedData));
              } else {
                  fetch("https://cms.baadmay.com/Fees?merchant_name=" + domainShop)
                    .then(response => response.json())
                    .then(data => {
                        sessionStorage.setItem("baadmayData", JSON.stringify(data));
                        processData(data);
                    })
                    .catch(error => console.error("Error fetching data:", error));
              }
          }
        
          function processData(result) {
              var valAdd = result[0].fee;
              var divVal = parseInt(valAdd) / 100;
              sessionStorage.setItem("percentageAmount", divVal);
              var perctoAddCartPage1 = sessionStorage.getItem("percentageAmount");
        
              var priceDivideElements = document.querySelectorAll('baadmaypricerre');
              priceDivideElements.forEach(priceDivideElement => {
                  var cartPageTotal1 = parseFloat(priceDivideElement.getAttribute('total-cart-price'));
                  var multiCartPrice1 = cartPageTotal1 * perctoAddCartPage1;
                  var finalCartPrice1 = Math.floor(parseFloat(cartPageTotal1 + multiCartPrice1) / 3);
        
                  priceDivideElement.textContent = parseFloat(finalCartPrice1).toLocaleString();
              });
          }
        
          calculateCartInstallment();
          
          var venobox = new VenoBox({
            selector: '.baadmay-modal',
            closeColor: '#000',
            closeBackground: 'transparent',
            overlayColor: 'rgba(0,0,0,.75)',
            overlayClose: false,
            customClass: 'baadmay-modal-container',
          });
        
          document.addEventListener('click', function(event) {
            if (event.target.classList.contains('baadmay-popup-close')) {
              venobox.close();
            }
          });
        }, 1500);
        // BaadMay code end for cart drawer
        console.log('hit')

        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
console.log('formData --> ', formData)
        if (this.cart) {
console.log('hit  this cart ', this.cart)
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
console.log('hit add cart rep status')
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
console.log('calling')
                if (document.querySelector('#cart-icon-bubble-bar .price')) {
      if (document.querySelector('#cart-icon-bubble')) {
        document.querySelector('#cart-icon-bubble-bar .price').innerHTML =  document.querySelector('#cart-icon-bubble .price')?.innerHTML || document.querySelector('#cart-icon-bubble')?.lastElementChild.innerHTML;
        const cartIconPrice = document.querySelector('#cart-icon-bubble').lastElementChild
          cartIconPrice.addEventListener("change", () => {
          document.querySelector('#cart-icon-bubble-bar .price').innerHTML = document.querySelector('#cart-icon-bubble .price')?.innerHTML || document.querySelector('#cart-icon-bubble')?.lastElementChild.innerHTML;
        });
      } else {
        document.querySelector('#cart-icon-bubble-bar .price').style.display = 'none';
      }
    }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
